module.exports = __webpack_public_path__ + "static/media/24UHCHR14.3a5dbc4c.jpg";